/*
 ** vue router: eLCVentory
 */
import type { RouteRecordRaw } from 'vue-router';

const vrteLCVentory: RouteRecordRaw = {
  path: '/eservices/elcventory',
  name: 'vrteLCVentory',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'view',
      name: 'vrteLCVentoryHistory',
      component: () => import('./vpgeLCVentoryHistory.vue'),
    },
    {
      path: 'update',
      name: 'vrteLCVentoryUpdate',
      component: () => import('./vpgeLCVentoryUpdate.vue'),
    },
    {
      path: 'submit',
      name: 'vrteLCVentorySubmit',
      component: () => import('./vpgeLCVentorySubmit.vue'),
    },
    {
      path: 'details',
      name: 'vrteLCVentoryDetails',
      component: () => import('./vpgeLCVentoryDetails.vue'),
    },
    {
      path: 'report',
      name: 'vrteLCVentoryReport',
      component: () => import('./vpgeLCVentoryReport.vue'),
    },
    {
      path: 'hoto',
      name: 'vrteLCVentoryHOTO',
      component: () => import('./vpgeLCVentoryHOTO.vue'),
    },
    {
      path: 'return',
      name: 'vrteLCVentoryReturn',
      component: () => import('./vpgeLCVentoryReturn.vue'),
    },
    {
      path: 'return',
      name: 'vrteLCVentoryAssign',
      component: () => import('./vpgeLCVentoryAssign.vue'),
    },
    {
      path: 'edit',
      name: 'vrteLCVentoryEdit',
      component: () => import('./vpgeLCVentoryEdit.vue'),
    },
    {
      path: 'adjust',
      name: 'vrteLCVentoryAdjust',
      component: () => import('./vpgeLCVentoryAdjust.vue'),
    },
    {
      path: 'item',
      name: 'vrteLCVentoryItemEdit',
      component: () => import('./vpgeLCVentoryItemEdit.vue'),
    },
    {
      path: 'admin',
      name: 'vrteLCVentoryAdmin',
      component: () => import('./vpgeLCVentoryAdmin.vue'),
    },
  ],
};

export default vrteLCVentory;
